import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import {connect} from "react-redux";
import { getSectionTitle,setRoomMessages,setSecondUser } from "../../redux/actions/actions.js";
import Messages_Left from "./Messages_Left.js";
import Messages_Right from "./Messages_Right.js";

const Messages = (props) => {
    useEffect(() => {
        props.onGetSectionTitle("Messages");
        props.onSetRoomMessages();
        props.onSetSecondUser();
    },[])
    return(
        <div className="main_content_section_main messages">
            <Messages_Left />
            <Messages_Right />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        title: state.getSectionTitle.title,
        second_user: state.getSecondUser.second_user
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onGetSectionTitle: (text) => dispatch(getSectionTitle(text)),
        onSetRoomMessages: () => dispatch(setRoomMessages()),
        onSetSecondUser: () => dispatch(setSecondUser())
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Messages);